<template>
  <div>
    <img class="imgs" :src="imgUrl" alt="" />
  </div>
</template>

<script>
export default {
  created() {
    this.getQuery();
  },
  data() {
    return {
      imgUrl: "",
      queryMsg: {},
    };
  },
  methods: {
    getQuery() {
      this.queryMsg = this.$route.query;
      console.log("this.queryMsg", this.queryMsg);
      // 判断有无图片链接
      if (this.queryMsg.url) {
        this.imgUrl = this.queryMsg.url;
        // 判断有无标题
        if (this.queryMsg.title) {
          document.title = this.queryMsg.title;
        }
        // 没有标题则使用图片名称
        else {
          const lastSlashIndex = this.queryMsg.url.lastIndexOf("/");
          const fileNameEncoded = this.queryMsg.url.slice(lastSlashIndex + 1);
          const name = fileNameEncoded.split(".");
          document.title = name[0];
        }
      }
      // 判断有无标题，有标题则覆盖图片名称
      if (this.queryMsg.title) {
        document.title = this.queryMsg.title;
      }
    },
  },
};
</script>
<style scoped>
.imgs {
  display: block;
  width: 100%;
  /* height: 100%; */
}
</style>


// WEBPACK FOOTER //
// src/view/imgPage/index.vue